<script setup lang="ts">
import type { TooltipPlacement } from 'vidstack';

import Tooltip from '../Tooltip.vue';
import { localize } from '@/front/composables/StringComposer'
import { useI18n } from 'vue-i18n'
const { t } = useI18n({
  useScope: 'global'
});


const { tooltipPlacement } = defineProps<{
  tooltipPlacement: TooltipPlacement;
}>();

import { ClickStore } from '@/front/stores/click_store'
const clickStore = ClickStore()

const handleClick = () => {
  log.info(5,'handleClick genie')
  // clickStore.startParticipate()
  clickStore.startGenie()
}
</script>

<template>
  <Tooltip :placement="tooltipPlacement">
    <template #trigger>
      <media-play-button
        id="genie-button"
        class="w-6 h-6 @2xs/player:w-8 @2xs/player:h-8 @lg/player:w-10 @lg/player:h-10 @2xl/player:w-12 @2xl/player:h-12  ring-media-focus group relative inline-flex cursor-pointer items-center justify-center rounded-md outline-none ring-inset hover:bg-white/20 data-[focus]:ring-4 aria-hidden:hidden"
        @click.stop="handleClick"
        @touchstart.stop="handleClick"
      >
      <media-icon type="comment"></media-icon>
      </media-play-button>
    </template>

    <template #content>
      <span>{{ localize('ask_a_question', t) }}</span>
    </template>
  </Tooltip>
</template>
